import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    limit, orderBy
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";
import {DATA_LIMIT} from "../constants/shopify.constant";

export {
    addShopifyBulkOperations,
    updateShopifyBulkOperations,
    updateSingleShopifyBulkOperation,
    deleteSingleShopifyBulkOperation,
    getSingleShopifyBulkOperation,
    searchShopifyBulkOperations,
    getAllPODShopifyBulkOperations,
    prepareShopifyBulkOperationsList
}

const collectionName = 'shopify-bulk-operations';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyBulkOperations = (shopifyBulkOperations) => {
    return Promise.map(shopifyBulkOperations, async shopifyBulkOperation => {
        console.log('.');
        await addSingleShopifyBulkOperation(shopifyBulkOperation);
    });
}

const updateShopifyBulkOperations = (shopifyBulkOperations) => {
    return Promise.map(shopifyBulkOperations, async shopifyBulkOperation => {
        console.log('.');
        await updateSingleShopifyBulkOperation(shopifyBulkOperation);
    });
}

const addSingleShopifyBulkOperation = (shopifyBulkOperation) => {
    return addDoc(collectionReference, shopifyBulkOperation);
}

const updateSingleShopifyBulkOperation = (shopifyBulkOperation) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkOperation.id);
    return setDoc(documentReference, shopifyBulkOperation);
}

const deleteSingleShopifyBulkOperation = (shopifyBulkOperation) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkOperation.id);
    return deleteDoc(documentReference);
}

const getSingleShopifyBulkOperation = (shopifyBulkOperationId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkOperationId);
    return getDoc(documentReference);
}

const searchShopifyBulkOperations = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);
    // searchQuery = query(searchQuery, orderBy('id', 'desc'));

    if (_.isEmpty(searchCriteriaList)) {
        searchQuery = query(searchQuery, orderBy('id', 'desc'));
        // searchQuery = query(searchQuery, orderBy('createdAt', 'desc'));
    }

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    // searchQuery = query(searchQuery, orderBy('id', 'desc'));
    searchQuery = query(searchQuery,
        limit(perPage));

    const shopifyBulkOperationResult = await getDocs(searchQuery);
    return prepareShopifyBulkOperationsList(shopifyBulkOperationResult);
}

const getAllPODShopifyBulkOperations = async (podId) => {
    let searchQuery = query(collectionReference,
        where("podId", "==", podId));

    const shopifyBulkOperationResult = await getDocs(searchQuery);
    return prepareShopifyBulkOperationsList(shopifyBulkOperationResult);
}

const prepareShopifyBulkOperationsList = (shopifyBulkOperationResult) => {
    const shopifyBulkOperationsList = [];

    _.forEach(shopifyBulkOperationResult.docs, shopifyBulkOperationDoc => {
        shopifyBulkOperationsList.push({
            ...shopifyBulkOperationDoc.data(),
            id: shopifyBulkOperationDoc.id
        });
    });

    return shopifyBulkOperationsList;
}
